import React from 'react';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import styles from './style';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  modalTitle: string;
  children?: React.ReactNode;
};
const KitmanModal = (props: Props) => {
  return (
    <Modal
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      open={props.isOpen}
      onClose={props.onClose}
    >
      <Stack sx={styles.modalBackground}>
        <Typography sx={styles.modalTitle}>{props.modalTitle}</Typography>
        {props.children}
      </Stack>
    </Modal>
  );
};

export default KitmanModal;
